import { Tooltip } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { useOctopusTheme } from "~/components/Theme";
import Chip from "../Chips/Chip";
import DeletableChip from "../Chips/DeletableChip";
interface CommonCustomFieldProps {
    description: string;
    customFieldValueName: string;
    customFieldValueColor: string;
    borderColor?: string;
    small?: boolean;
    showTooltip?: boolean;
    tooltipLabel?: string;
    tabIndex?: number;
    onClick?: () => void;
}
interface DeletableCustomFieldProps extends CommonCustomFieldProps {
    onRequestDelete: () => void;
    deleteButtonAccessibleName: string;
}
type CustomFieldProps = CommonCustomFieldProps | DeletableCustomFieldProps;
function isDeletableCustomField(customFieldProps: CustomFieldProps): customFieldProps is DeletableCustomFieldProps {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (customFieldProps as DeletableCustomFieldProps).onRequestDelete !== undefined;
}
const CustomField: React.FC<CustomFieldProps> = (props) => {
    const theme = useOctopusTheme();
    const { customFieldValueName, customFieldValueColor, tabIndex, description, onClick, borderColor, tooltipLabel, small = false } = props;
    const label = tooltipLabel ? tooltipLabel : "CustomField";
    const customFieldDescription = description ? `${customFieldValueName}: ${description}` : `${label}: ${customFieldValueName}`;
    if (!small) {
        if (isDeletableCustomField(props)) {
            return (<DeletableChip onRequestDelete={props.onRequestDelete} deleteButtonAccessibleName={props.deleteButtonAccessibleName} backgroundColor={customFieldValueColor} borderColor={borderColor} description={customFieldDescription} labelColor={theme.whiteConstant}>
                    {customFieldValueName}
                </DeletableChip>);
        }
        return (<Chip tabIndex={tabIndex} onClick={onClick} backgroundColor={customFieldValueColor} borderColor={borderColor} description={customFieldDescription} labelColor={theme.whiteConstant}>
                {customFieldValueName}
            </Chip>);
    }
    return (<Tooltip content={customFieldValueName}>
            <em className={`${"fa-solid fa-square customField-swatch"}`} style={{ color: customFieldValueColor, marginLeft: "0.0625rem", marginRight: "0.0625rem" }}/>
        </Tooltip>);
};
CustomField.displayName = "CustomField"
export default CustomField;
